<template>
  <div class="About">

    <slider :items="items" v-if="animal.id" />

  </div>
</template>

<script>
import Slider from 'components/Slider/Slider'

export default {
  name: 'About',

  components: {
    Slider
  },

  watch: {
    '$route.query.page' () {
      this.$analytics.event(`About/Page${this.$route.query.page}`)
    }
  },

  mounted () {
    // Wait a little for the analytics start event to dispatch
    setTimeout(() => {
      this.$analytics.event(`About/Page1`)
    }, 100)
  },

  computed: {
    animal () { return this.$store.state.animal },
    suiteIsUnoccupied () { return this.$store.state.suiteIsUnoccupied },

    items () {
      const items = []

      let firstImage

      if (this.animal.images.length && this.animal.images[0].image) {
        firstImage = this.animal.images[0].image
      }

      // Create first slider item
      // - If suite is unoccupied, we're going to show a special message
      if (this.suiteIsUnoccupied) {
        items.push({
          image: firstImage,
          template: 'text',
          content: {
            title: 'Adoptable Pets Coming Soon!',
            text: 'Interested in adopting a pet?<br> Select “Adopt” to learn about<br> the Annenberg PetSpace<br> adoption process.'
          }
        })
      } else {
        items.push({
          image: firstImage,
          template: 'text',
          content: {
            title: `About ${this.animal.name}`,
            subtitle: this.animal.age,
            subtitle2: this.animal.sex,
            subtitle3: this.animal.weight,
            text: this.animal.aboutDescription,
            footer: `Swipe to see additional photos of ${this.animal.name}`
          }
        })
      }

      if (!this.animal.images || !this.animal.images.length || this.suiteIsUnoccupied) {
        return items
      }

      // Add additional slider items for each image
      this.animal.images.forEach(image => {
        items.push({ image: image.image })
      })

      // Add additional slider item for video
      if (this.animal.videoUrl) {
        items.push({
          template: 'video',
          video: this.animal.videoUrl
        })
      }

      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?118f96f4